<template>
  <section>
    <p :class="$style.requirements">{{ $t("photo_requirements") }}</p>
    <ul :class="$style.list">
      <li
        v-for="(item, index) in $t('requirements_list')"
        v-html="item"
        :key="index"
      ></li>
    </ul>
    <a
      href="javascript: void 0"
      :class="$style.examples"
      @click.prevent="isExamplesModalVisible = true"
    >
      {{ $t("Examples") }}
    </a>
    <a-modal
      centered
      :visible="isExamplesModalVisible"
      :closable="false"
      :bodyStyle="{ textAlign: 'center' }"
      :getContainer="() => $root.$el"
      :footer="null"
      :width="720"
      :zIndex="1100"
      @cancel="isExamplesModalVisible = false"
    >
      <section :class="$style.modal">
        <img v-for="(img, index) in imgExamples" :src="img" :key="index" />
      </section>
      <p :class="$style.photo">{{ $t("photo_examples") }}</p>
      <a-button type="primary" @click="isExamplesModalVisible = false">
        {{ $t("Okay") }}
      </a-button>
    </a-modal>
  </section>
</template>

<script>
import { Button, Modal } from "ant-design-vue";

export default {
  name: "PhotoExample",
  data() {
    return {
      isExamplesModalVisible: false
    };
  },
  components: {
    [Button.name]: Button,
    [Modal.name]: Modal
  },
  computed: {
    imgExamples() {
      return this.$i18n.locale === "zh"
        ? [
            require("@/assets/img/passport/zh-1.jpg"),
            require("@/assets/img/passport/zh-2.jpg"),
            require("@/assets/img/passport/zh-3.jpg"),
            require("@/assets/img/passport/zh-4.jpg"),
            require("@/assets/img/passport/zh-5.jpg"),
            require("@/assets/img/passport/zh-6.jpg")
          ]
        : [
            require("@/assets/img/passport/en-1.jpg"),
            require("@/assets/img/passport/en-2.jpg"),
            require("@/assets/img/passport/en-3.jpg"),
            require("@/assets/img/passport/en-4.jpg"),
            require("@/assets/img/passport/en-5.jpg"),
            require("@/assets/img/passport/en-6.jpg")
          ];
    }
  }
};
</script>

<style lang="scss" module>
.requirements {
  color: #e3342f;
  margin: 0.5em 0;
  padding: 0 1em;
}
.list {
  list-style-type: "- ";
  padding-left: 1em;
}
a.examples {
  color: #e3342f;
  margin: 0 1em;
  text-decoration: underline;
  &:hover {
    color: #e3342f;
    text-decoration: none;
  }
  &:active {
    opacity: 0.7;
  }
}
.modal {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  text-align: center;
  & > img {
    width: 30%;
  }
}
.photo {
  color: #e3342f;
  margin: 1.5em 0;
}
</style>
